import { MailboxMockApi } from "./apps/mailbox/api";

export const mockApiServices = [
 
    MailboxMockApi,
 
];
